export default __webpack_public_path__ + "static/media/cc-public_domain_mark_white.f29238be.svg";